/**
 * Patient portal.
 *
 * §18 puts "patient portal basics" in Phase 1. The security foundation was
 * proven before this app existed: section 10 of tools/smoke/phase1-exit.mjs
 * signs a patient in, reads their own record, and is REFUSED another patient's
 * (§16.6). This is the surface on top of that.
 */

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import type { JSX } from 'react';

import { router } from './router.js';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      // One retry. A patient staring at a spinner is worse than a patient
      // seeing an error they can act on, and a REFUSAL must not be retried
      // into looking like a network problem.
      retry: 1,
    },
  },
});

export const App = (): JSX.Element => (
  <QueryClientProvider client={queryClient}>
    <RouterProvider router={router} />
  </QueryClientProvider>
);
